<script>
    import ClientData from "./ClientData";
    import DialogButton from "../../dialog/components/dialog-button.vue";
    import ClientDialogCoordinateDialog from "./client-dialog-coordinate-dialog.vue";
    import SquareButton from "../../content/common/squareButton.vue";

    export default {
        name: "client-dialog-location-image",
        components: {SquareButton, ClientDialogCoordinateDialog, DialogButton},
        props: {
            clientData: ClientData,
        },
        computed: {
            projectId() {
                return Laravel.activeProject;
            },
            translations() {
                return {
                    locationPlan: Lang.langGet("Location Plan"),
                    noPicture: Lang.langGet("No picture uploaded."),
                    uploadPicture: Lang.langGet("Upload Picture"),
                    deletePicture: Lang.langGet("Delete Picture"),
                }
            }
        },
        methods: {
            uploadPicture(event) {
                const files = event.target.files || event.dataTransfer.files;
                if (!files.length) return;

                const reader = new FileReader();
                reader.onload = e => {
                    this.clientData.addNewLocationPlan(e.target.result);
                    this.clientData.hasNewLocationPlan = true;
                };
                reader.readAsDataURL(files[0]);
            },
            deletePicture() {
                this.clientData.deleteLocationPlan();
                this.clientData.hasNewLocationPlan = true;
            },
            handleUpdateCoordinates(x, y) {
                this.clientData.updateCoordinates(x, y);
            }
        }
    }
</script>

<template>
    <div class="client-dialog-location-image">
        <div class="px-4">{{translations.locationPlan}}</div>
        <div v-if="clientData.getLocationPlan()"
             class="location-image-container d-flex align-center elevation-2-inset justify-center flex-column py-4 mx-4"
             style="background-color: #e5e5e5;"
        >
            <img
                 class="location-image"
                 :alt="clientData.addNewLocationModeActive() ? 'New Location Plan' : clientData.locationName"
                 :src="clientData.getLocationPlanStoragePath(projectId)"
            />
        </div>
        <div v-else>
            <div
                class="location-image-container elevation-2-inset d-flex justify-center align-center py-4 mx-4"
                style="background-color: #e5e5e5; font-size: 1.2rem"
            >
                {{translations.noPicture}}
            </div>
        </div>
        <div v-if="clientData.getLocationPlan() || clientData.locationPlanNew" class="delete-icon">
            <square-button
                flat
                :tooltip-text="translations.deletePicture"
                icon="far fa-trash"
                @click=deletePicture
            />
        </div>
        <div class="d-flex flex-row w-100">
            <div class="w-50 pa-4">
                <client-dialog-coordinate-dialog
                    :clientData="clientData"
                    :imageSrc="clientData.getLocationPlanStoragePath(projectId)"
                    @save="handleUpdateCoordinates"
                />
            </div>
            <div class="flex-grow-1 pa-4">
                <dialog-button class="w-100" color="secondary">
                    <label class="cursor-pointer font-weight-regular">
                        {{translations.uploadPicture}}
                        <input class="hidden"
                               :title="translations.uploadPicture"
                               ref="upload"
                               accept="image/jpeg,image/png"
                               name="location_plan" type="file"
                               @change="uploadPicture"
                        >
                    </label>
                </dialog-button>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .location-image-container {
        height: 20vh;
        border-radius: 8px;
    }
    .location-image {
        height: 18vh;
        max-width: 100%;
        border-radius: 8px;
    }
    .delete-icon {
        position: absolute;
        bottom: 74px;
        right: 24px;
    }
    .client-dialog-location-image {
        position: relative;
    }
</style>
